import { useEffect } from 'react';

import { useForwardCatalog } from '@/features/Catalog/api';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';

import { SELECTOR_MODES, setSymbols } from '../store/symbolSelector.slice';
import {
  expandForwardCurveWildcards,
  hasForwardCurveWildcard
} from '../utils/expandForwardCurveWildcards';

/**
 * Single source of truth for `Period: '*'` resolution. Anything that lands in
 * the selector with a wildcard period (e.g. a past forward curve export) is
 * expanded against the forward catalog into the full period set, so curve
 * details counts and export payloads always see the real periods.
 */
const useResolveForwardCurveWildcards = () => {
  const dispatch = useAppDispatch();
  const selectorMode = useAppSelector(state => state.symbolSelector.selectorMode);
  const symbols = useAppSelector(state => state.symbolSelector.symbols);
  const { data: forwardCatalog } = useForwardCatalog();

  useEffect(() => {
    if (selectorMode !== SELECTOR_MODES.FORWARD_CURVE) return;
    if (!forwardCatalog) return;
    if (!hasForwardCurveWildcard(symbols)) return;

    const expanded = expandForwardCurveWildcards(symbols, forwardCatalog);
    if (expanded === symbols) return;

    dispatch(setSymbols(expanded));
  }, [selectorMode, symbols, forwardCatalog, dispatch]);
};

export default useResolveForwardCurveWildcards;
